import MainImg from "../images/chooseUs/main.png";
import Box1 from "../images/chooseUs/icon1.png";
import Box2 from "../images/chooseUs/icon2.jpg";
import Box3 from "../images/chooseUs/icon3.jpg";
import Box4 from "../images/chooseUs/icon4.jpg";

function ChooseUs() {
  return (
    <>
      <section  id="choosing-section"   className="choose-section" style={{marginTop:'-25px'}}>
        <div className="container">
          <div className="choose-container">
            <img
              className="choose-container__img"
              src={MainImg}
              alt="car_img"
            />
            <div className="text-container">
              <div className="text-container__left">
                <h4>Choosing Us Is Wise</h4>
                <h2>The Best Atv Provider</h2>
                <p>
                Embark on an effortless rental journey in Turks and Caicos with Price Is Right ATV. Discover incredible deals on our fleet of reliable ATVs and jet skis, designed to suit your adventurous spirit. We prioritize affordability, ensuring top-notch services that fit your budget. Explore the breathtaking beauty of the islands at your own pace, whether riding through scenic trails or cruising the crystal-clear waters. Don’t miss out on creating unforgettable memories with our hassle-free, budget-friendly rental options. Secure your ride today and elevate your island experience!
                </p>

             
               
              </div>
              <div className="text-container__right">
                {/*
                <div className="text-container__right__box">
                  <img src={Box1} alt="car-img" />
                  <div className="text-container__right__box__text">
                    <h4>All Vehicle Types</h4>
                    <p>
                     With all variety of vehicle types, take your driving experience to next level.
                    </p>
                  </div>
                </div>/
*/}

                
                <div className="text-container__right__box">
                  {" "}
                  <img src={Box2} alt="coin-img" />
                  <div className="text-container__right__box__text">
                    <h4>All Inclusive Pricing</h4>
                    <p>
                      Get everything you need in one convenient, transparent
                      price with our all-inclusive pricing policy.
                    </p>
                  </div>
                </div>


                <div className="text-container__right__box">
                  {" "}
                  <img src={Box4} alt="coin-img" />
                  <div className="text-container__right__box__text">
                    <h4>Road Side Assistance</h4>
                    <p>
                    We provide prompt roadside assistance to our customers in need.
                    </p>
                  </div>
                </div>




                <div className="text-container__right__box">
                  {" "}
                  <img src={Box3} alt="coin-img" />
                  <div className="text-container__right__box__text">
                    <h4>Quick Customer Support</h4>
                    <p>
                     We love our customers, get lightening support from our customer support.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ChooseUs;
